import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule as AngularFormsModule, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderComponent } from './order/order.component';
import { ConfirmDialogModule } from 'primeng/primeng';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFormsModule,
    ConfirmDialogModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TranslateModule,
  ],
  declarations: [OrderComponent]
})
export class OrderModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/order/order.module.ts